<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Due Tasks
              </h2>
              <div>
                <select v-model="viewUser">
                  <option value="me">My Clients</option>
                  <option value="all">All Users Clients</option>
                  <option v-for="user in searchableUsers" v-bind:value="user.username">{{user.firstName}} {{user.lastName}}</option>
                </select>
              </div>
              <div>
                <select v-model="viewType">
                  <option value="all">All Task Types</option>
                  <option value="Screenshot">Screenshots Required</option>
                  <option value="No Domains">Domains Required</option>
                  <option value="No Keywords">Keywords Required</option>
                  <option value="About Me is Unfilled">About Me Required</option>
                  <option value="Unsent">Sent PDFs Not Up to Date</option>
                  <option value="nocampaign">Client Has No Campaigns</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <paged-api-table
                v-bind:columns="taskColumns"
                module="DueTasks"
                default-sort="client ASC"
                v-bind:custom-data-source="dueTaskApi"
                v-bind:refresh-for-id="lastRefreshTime"
                v-bind:per-page="tasksPerPage">
                </paged-api-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  import AuthToken from "../api/authtoken.js";
  import WebLLCRESTApi from "../api/api.js";
  import { Usernames } from "../util/usernames.js";
  import Cookies from "js-cookie";
  
  export default {
    
    created() {
      const usersApi = new WebLLCRESTApi("Users", this.$router);
      this.users = usersApi.getData(null, {
        order: ["firstName ASC", "lastName ASC"]
      });
      
      (async () => {
        this.searchableUsers = (await this.users).filter((user) => {
          return user.role == "admin" || user.role == "account";
        });
      })();
      
      this.dueTaskApi = {
        getData: async (refreshPageCount, curPage, perPage, sortFilter, whereFilter) => {
          const api = new WebLLCRESTApi("Due-Tasks");
          
          const args = [
            { name: "order", value: sortFilter },
            { name: "viewuser", value: this.viewUser.toString() }
          ];
          
          const res = await api.remoteMethod("view", args, true);
          const dataRaw = await res.json();
          const data = this.filterByType(dataRaw, this.viewType);
          
          if(data.length > this.tasksPerPage) {
            const offset = curPage * perPage;
            const endOffset = (curPage + 1) * perPage;
            
            const dataSnippet = data.slice(offset, Math.min(endOffset, data.length));
            
            return {
              totalCount: data.length,
              data: dataSnippet
            };
          }
          else {
            return {
              totalCount: data.length,
              data: data
            };
          }
        }
      };
    },
    
    data() {
      const authToken = AuthToken.getAuthObject();
      
      return {
        taskColumns: [
          { key: "client", "text": "Client", type: "String", sort: true },
          { key: "campaign", "text": "Campaign", type: "String" },
          { key: "owner", "text": "Acct Manager", type: "String", sort: true, fnAsyncLoad: (item) => { return Usernames.getUserFullName(this.users, item.owner) } },
          { key: "authBasicUser", "text": "Assistant", type: "String", fnAsyncLoad: (item) => { return Usernames.showBasicAuthUsers(this.users, item); } },
          { key: "details", "text": "View Client", type: "Route", route: "/client/:id" },
        ],
        
        viewUser: (authToken.role == "admin" ? "all" : "me"),
        viewType: "all",
        users: null,
        searchableUsers: [],
        dueTaskApi: "waiting",
        tasksPerPage: Math.max((Cookies.get('clientPerPage') ? parseInt(Cookies.get('clientPerPage')) : 20), 20),
        lastRefreshTime: "0"
      }
    },
    
    methods: {
      filterByType(tasks, viewType) {
        if(viewType == "all")
          return tasks;
        
        return tasks.filter((task) => {
          return task.taskTypes.indexOf(viewType) != -1;
        });
      }
    },
    
    watch: {
      viewUser(to, from) {
        // invalidate table
        this.lastRefreshTime = Date.now().toString();
      },
      
      viewType(to, from) {
        // invalidate table
        this.lastRefreshTime = Date.now().toString();
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DueTasks.vue